import client from '@common/utils/rest';
import { IMPORT_TYPE } from '../pedigree-import.constants';

const URL_PREFIX = 'pedigreeservice/v2/import';

const getUrl = (path) => {
  return `${URL_PREFIX}/${path}`;
};

export const getFolders = () => {
  return client({
    path: getUrl('formatFolders'),
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const getFormats = (folderId) => {
  return client({
    path: getUrl('formats'),
    params: {
      folderId
    },
    method: 'GET',
  }).then((response) => {
    return response.entity.map(({ formatId, formatName, ...otherData }) => {
      return {
        ...otherData,
        id: formatId,
        name: formatName,
      }
    });
  });
};

export const createFolder = ({ name, parentId }) => {
  return client({
    path: getUrl('formatFolder'),
    method: 'POST',
    entity: {
      folderName: name,
      parentId: parentId || 0,
    },
  });
};

export const deleteFolder = (id) => {
  return client({
    path: getUrl('formatFolderDelete'),
    params: {
      folderId: id,
    },
    method: 'POST',
  });
};

export const deleteFormat = (id) => {
  return client({
    path: getUrl('formatDelete'),
    params: {
      formatId: id
    },
    method: 'POST',
  });
};

export const createFormat = (data) => {
  return client({
    path: getUrl('format'),
    method: 'POST',
    entity: data,
  });
};

export const uploadFile = (file, delimiter) => {
  return client({
    path: getUrl('previewData'),
    method: 'POST',
    entity: {
      Filedata: file,
    },
    params: {
      delimiter,
    },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(({ entity }) => {
    const columns = entity[0];
    entity.shift();
  
    return {
      columns,
      data: entity.map((x) => {
        return x.reduce((acc, value, i) => {
          acc[columns[i]] = value;
  
          return acc;
        }, {});
      })
    };
  });
};

export const autoBuild = () => {
  return client({
    path: getUrl('autoBuild'),
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const getFieldChooserFolders = ({ context }) => {
  return client({
    path: getUrl('fieldChooser'),
    params: {
      folderId: 0,
      context,
    },
    method: 'GET',
  }).then((response) => {
    const foldersByType = response.entity.folders.reduce((acc, folder) => {
      if (folder.system) {
        folder.imageURL = 'gif/system.gif';
        folder.imageURLSelected = 'gif/system.gif';

        acc.system.push(folder);
      } else {
        acc.custom.push(folder);
      }

      return acc;
    }, { custom: [], system: [] });

    const config = {
      [IMPORT_TYPE.individuals]: {
        name: 'Individual Data Folders',
      },
      [IMPORT_TYPE.pedigrees]: {
        name: 'Pedigree Data Folders',
      },
    };

    const createRootFolder = ({ id, name, children, imageURL, system }) => {
      return {
        id, 
        name,
        children,
        imageURL,
        system,
        imageURLSelected: imageURL,
      };
    };

    const customRootFolder = createRootFolder({
      id: '',
      name: config[context].name,
      children: foldersByType.custom,
      imageURL: 'gif/df_individual.gif',
      system: false,
    });

    return [
      customRootFolder
    ];
  });
};

export const getFieldChooserFields = ({ folderId, context }) => {
  return client({
    path: getUrl('fieldChooser'),
    params: {
      folderId,
      context,
    },
    method: 'GET',
  }).then((response) => {
    return response.entity.fields.map(({ id, name, system, ...otherData }) => ({ ...otherData, fieldName: name, fieldId: id, systemField: system }));
  });
};

export const importPedigree = (data) => {
  return client({
    path: getUrl('pedigree'),
    method: 'POST',
    entity: data,
  }).then((response) => {
    return response.entity;
  });
};

export const importIndividual = (data) => {
  return client({
    path: getUrl('singlets'),
    method: 'POST',
    entity: data,
  }).then((response) => {
    return response.entity;
  });
};